<ion-header>
  <ion-toolbar color="primary">
    <ion-title>
      <span translate>static.settings.title</span>
    </ion-title>
    <ion-buttons slot="end">
      <div status-bar></div>
    </ion-buttons>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-text showWhen="ios" translate>static.close</ion-text>
        <ion-icon name="close-outline" showWhen="android,desktop" size="large"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-list-header>
      <span translate>static.settings.general</span>
    </ion-list-header>
    <ion-item>
      <ion-icon name="flag" slot="start"></ion-icon>
      <ion-select [label]="'static.settings.language' | translate" [(ngModel)]="language" (ngModelChange)="settingChange('lang', language)">
        <ion-select-option value="platform">Platform ({{ platformLanguage }})</ion-select-option>
        <ion-select-option value="fr">Français</ion-select-option>
        <ion-select-option value="en">English</ion-select-option>
        <ion-select-option value="ar" translate>Arabic</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-list-header>
      <span translate>static.settings.media</span>
    </ion-list-header>
    <ion-item>
      <ion-range [(ngModel)]="cameraQuality" min="1" max="100" (ngModelChange)="settingChange('camera_quality', cameraQuality)">
        <div slot="label" class="badged-label">
          <span translate>static.settings.cameraquality</span>
          <ion-badge slot="end">{{ cameraQuality }}</ion-badge>
        </div>
        <ion-icon range-left size="small" name="image"></ion-icon>
        <ion-icon range-right name="image"></ion-icon>
      </ion-range>
    </ion-item>

    <ion-list-header>
      <span translate>static.settings.equipment</span>
    </ion-list-header>
    <ion-item *ngIf="equipment">
      <ion-icon [name]="equipment.icon" slot="start"></ion-icon>
      <ion-label>{{ deviceName }}</ion-label>
      <ion-button style="width: 40px; height: 40px;" slot="end" color="danger" (click)="clearData()">
        <ion-icon slot="icon-only" name="trash"></ion-icon>
      </ion-button>
    </ion-item>
  </ion-list>
</ion-content>
